export default "__VITE_ASSET__BJE9nu$V__"